import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const visitorRegisterService = (action: any) => {
  return {
    postVisitorRegister: () => {
      const url = `${API_BASE_ADDRESS}/visitor/yoyaku/reservation-insert`;
      const payload = action.payload || {};
      return apiClient.post(url, payload);
    },
    getSimpleAuth: () => {
      let url = `${API_BASE_ADDRESS}/visitor/yoyaku/simple-auth?`;
      if (action.birthday && action.birthday !== '') {
        url += `&birthday=${action.birthday}`;
      }
      if (action.telephone && action.telephone !== '') {
        url += `&telephone=${action.telephone}`;
      }
      return apiClient.get(url);
    },
    getVisitorBlackListCheck: () => {
      let url = `${API_BASE_ADDRESS}/visitor/yoyaku/reservation-check?`;
      if (action.clubId && action.clubId !== 0) {
        url += `clubId=${action.clubId}&`;
      }
      if (action.contentsId && action.contentsId !== 0) {
        url += `contentsId=${action.contentsId}&`;
      }
      if (action.eqsId && action.eqsId !== 0) {
        url += `eqsId=${action.eqsId}&`;
      }
      if (action.contentsDate && action.contentsDate !== '') {
        url += `contentsDate=${action.contentsDate}&`;
      }
      if (action.startTime && action.startTime !== '') {
        url += `startTime=${action.startTime}&`;
      }
      if (action.endTime && action.endTime !== '') {
        url += `endTime=${action.endTime}&`;
      }
      if (action.fullLastName && action.fullLastName !== '') {
        url += `fullLastName=${action.fullLastName}&`;
      }
      if (action.fullFirstName && action.fullFirstName !== '') {
        url += `fullFirstName=${action.fullFirstName}&`;
      }
      if (action.visitorSei && action.visitorSei !== '') {
        url += `kanaLastName=${action.visitorSei}&`;
      }
      if (action.visitorMei && action.visitorMei !== '') {
        url += `kanaFirstName=${action.visitorMei}&`;
      }
      if (action.mail && action.mail !== '') {
        url += `mail=${action.mail}&`;
      }
      if (action.birthday && action.birthday !== '') {
        url += `birthday=${action.birthday}&`;
      }
      if (action.tel && action.tel !== '') {
        url += `tel=${action.tel}&`;
      }
      if (action.sex && action.sex !== '') {
        url += `sex=${action.sex}&`;
      }
      return apiClient.get(url);
    },
  };
};

export default visitorRegisterService;
